import React from 'react';


const PrivacyPolicy = () => { 
  
  return (
    <>
<div className="cgcontent">
    <div className="container">
        <div className="greenhead  text-center margint30">
            <img src="heading-custom.png" alt="Gate" className="marginauto img-responsive" />
            <h2>Privacy Policy</h2>
        </div>
        <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 padding15">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 padding20">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
            </div>
        </div>
    </div>
</div>
       </>
  );
};

export default PrivacyPolicy;
